module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-data-8cbc6a91d721dd97d409dbb6131ebfb4.svg";